import React from "react";
import styles from './drawingBoard.module.css';
import { useSelector } from "react-redux";
import { selectShowSpringCurve } from "./drawingBoardSlice";

const DrawingBoard = (props) => {
    const { width, height } = props;
    const showSpringCurve = useSelector(selectShowSpringCurve);
    return(
        <svg
            width={width}
            height={height}
            viewBox="-2000 -15500 14000 16500"
            className={styles.drawingBoard}
            id="drawingBoard"
        >
            {props.children}
            <CoordenateAxes 
                textX="l/min"
                textY="bar"
            />
            <PressureLimits />
            <Grid
                gridSize={1000}
                from={{x: 0, y: 0}}
                to={{x: 10000, y: -15000}}
            />
            <text
                x={10600}
                y={500}
                fontSize={500}
            >l/min</text>
            <text
                x={-800}
                y={-10600}
                fontSize={500}
                fill="black"
            >bar</text>
            <text
                x={-1800}
                y={-10600}
                fontSize={500}
                fill="red"
            >kW</text>
            {showSpringCurve ? 
            <text
                x={-800}
                y={-11600}
                fontSize={500}
                fill="green"
            >bar</text>
            : null}
            {showSpringCurve ? 
            <text
                x={-1800}
                y={-11600}
                fontSize={500}
                fill="magenta"
            >kW</text>
                : null}
        </svg>
    );
}

const Grid = ({ gridSize, from, to }) => {
    const result = [];
    let k = 0;
    let _from_;
    let _to_;
    //vertical lines
    if  (to.x >= from.x){
        _from_=from.x;
        _to_=to.x;
    } else {
        _from_=to.x;
        _to_=from.x;
    }
    for (let i = _from_; i <= _to_; i += gridSize, k++){
        result[k] = 
            <line
                x1={i}
                y1={from.y}
                x2={i}
                y2={to.y}
                stroke="gray"
                strokeWidth={10}
                key={k}
            />
    }
    //horizontal lines
    if  (to.y >= from.y){
        _from_=from.y;
        _to_=to.y;
    } else {
        _from_=to.y;
        _to_=from.y;
    }
    for (let i =_from_; i <= _to_; i += gridSize, k++){
        result[k] = 
            <line
                x1={from.x}
                y1={i}
                x2={to.x}
                y2={i}
                stroke="gray"
                strokeWidth={10}
                key={k}
            />
    }
    return result;
}

const CoordenateAxes = () => {

    const drawHorizontalTicks = (howMany) => {
        const factor = 1000;
        const tickHeight = 150;
        const valuePerTick = 10;
        const result = [];
        for (let i = 0; i <= howMany; i++){
            result[i] = 
                <line 
                    x1={i*factor}
                    y1= {0}
                    x2={i*factor}
                    y2={tickHeight}
                    stroke="black"
                    strokeWidth={40}
                    key={i}
                />;
            result[i+howMany+1] = 
                <text
                    x={i*factor - 200}
                    y={500}
                    fontSize={400}
                    key={i+howMany+1}
                >
                    {i*valuePerTick}
                </text>
        }
        return result;
    }

    const drawVerticalTicks = (howMany, offset = 0, valuePerTick) => {
        const factor = 1000;
        const tickHeight = 150;
        const result = [];
        const numberPosOffset = (n) => {
            if (n < 10) return -450;
            if (n < 100) return -650;
            if (n < 1000) return -850;
            return -800;
        }
        for (let i = 0; i <= howMany; i++){
            result[i] = 
                <line 
                    y1={-(i*factor)}
                    x1={0 + offset}
                    y2={-(i*factor)}
                    x2={-tickHeight + offset}
                    stroke="black"
                    strokeWidth={40}
                    key={i}
                />;
            result[i+howMany+1] = 
                <text
                    y={-(i*factor - 200)}
                    x={numberPosOffset(i*valuePerTick) + offset}
                    fontSize={400}
                    key={i+howMany+1}
                >
                    {i*valuePerTick}
                </text>
        }
        return result;
    }

    return(
        <g>
            {drawHorizontalTicks(10)}
            {drawVerticalTicks(10, -0, 30)}
            {drawVerticalTicks(10, -1200, 1)}
            <line 
                x1={0}
                y1={0}
                x2={10500}
                y2={0}
                stroke="black"
                strokeWidth={20}
            />
            <line 
                x1={0}
                y1={0}
                x2={0}
                y2={-10550}
                stroke="black"
                strokeWidth={20}
            />
            <ArrowHead 
                x={10550}
                y={0}
                scale={100}
                angle={90}
            />
            <ArrowHead 
                x={0}
                y={-10550}
                scale={100}
            />
        </g>
    );
}

const ArrowHead = (props) => {
    const {x = 0, y = 0, scale = 1, angle = 0 } = props;
    return(
        <g
            transform={`translate(${x}, ${y}) rotate(${angle}) scale(${scale})`}
        >
            <path
                d="M0,0 l1,4 l-2,0 Z"
                fill="black"
            />
        </g>
    );
}

const PressureLimits = () => {
    return(
        <g>
            <text
                x={10550}
                y={-9830}
                fontSize={500}
            >P max</text>
            <text
                x={10550}
                y={-500}
                fontSize={500}
            >P min</text>
            
            <path
                d="M10000,-10000 l150,150 l250,0 l0,-300 l-250,0 Z"
                stroke="black"
                strokeWidth={40}
                fill="none"
            />
            <path
                d="M10000,-666 l150,150 l250,0 l0,-300 l-250,0 Z"
                stroke="black"
                strokeWidth={40}
                fill="none"
            />
        </g>
    );
}

export default DrawingBoard;
